import { render, staticRenderFns } from "./Mallki.vue?vue&type=template&id=aaa2fa9e&"
import script from "./Mallki.vue?vue&type=script&lang=js&"
export * from "./Mallki.vue?vue&type=script&lang=js&"
import style0 from "./Mallki.vue?vue&type=style&index=0&id=aaa2fa9e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_rpjj46s3fsyrbdrx36iiyr4l4y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\21.zhangzhiyi\\web-system\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa2fa9e')) {
      api.createRecord('aaa2fa9e', component.options)
    } else {
      api.reload('aaa2fa9e', component.options)
    }
    module.hot.accept("./Mallki.vue?vue&type=template&id=aaa2fa9e&", function () {
      api.rerender('aaa2fa9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextHoverEffect/Mallki.vue"
export default component.exports